import { ToastInfo, ToastSuccess } from '@/components/molecules/ToastTemplate/ToastTemplate';

/** `info` for a command the winch has started rather than finished, such as a move. */
export type WinchToastTone = 'success' | 'info' | 'error';

export function showWinchToast(content: string, tone: WinchToastTone, toastId: string): void {
    if (tone === 'success') {
        ToastSuccess(content, toastId, { icon: 'new_winch' });
        return;
    }
    ToastInfo({
        content,
        // The status colours the icon as well as the border; `type` alone set only the border.
        status: tone,
        icon: tone === 'error' ? 'error' : 'new_winch',
        options: {
            toastId,
            position: 'top-right',
            autoClose: 5000,
            closeOnClick: true,
            hideProgressBar: false,
            pauseOnHover: true,
        },
    });
}
